var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"physical-home-xianshi-list-time-container"},[_c('div',{staticClass:"left"},[_c('p',[_c('span',[_vm._v(_vm._s(_vm._f("returnTimeHours")(_vm.roundTime))+":00")]),_vm._v(" 点场 倒计时")])]),_c('div',{staticClass:"right"},[(_vm.roundTime)?_c('nr-count-down',{attrs:{"end":_vm.roundTime},on:{"onEnd":_vm.onChangeNext}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }